"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var XirrTransformationUtils_1 = require("./utils/XirrTransformationUtils");
var Headline_1 = tslib_1.__importDefault(require("../../headline/internal/Headline"));
/**
 * The React component that handles the transformation of the execution objects into the data accepted by the {@link Headline}
 * React component that this components wraps. It also handles the propagation of the drillable items to the component
 * and drill events out of it.
 */
var XirrTransformation = /** @class */ (function (_super) {
    tslib_1.__extends(XirrTransformation, _super);
    function XirrTransformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDisableDrillUnderlineFromConfig = function () {
            return _this.props.config ? _this.props.config.disableDrillUnderline : false;
        };
        _this.handleFiredDrillEvent = function (item, target) {
            var _a = _this.props, onDrill = _a.onDrill, dataView = _a.dataView;
            var drillEventData = XirrTransformationUtils_1.buildDrillEventData(item, dataView);
            sdk_ui_1.fireDrillEvent(onDrill, drillEventData, target);
        };
        return _this;
    }
    XirrTransformation.prototype.render = function () {
        var _a = this.props, drillableItems = _a.drillableItems, config = _a.config, onAfterRender = _a.onAfterRender, dataView = _a.dataView;
        var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(drillableItems);
        var data = XirrTransformationUtils_1.getHeadlineData(dataView);
        var dataWithUpdatedDrilling = XirrTransformationUtils_1.applyDrillableItems(data, drillablePredicates, dataView);
        var disableDrillUnderline = this.getDisableDrillUnderlineFromConfig();
        return (react_1.default.createElement(Headline_1.default, { data: dataWithUpdatedDrilling, config: config, onDrill: this.handleFiredDrillEvent, onAfterRender: onAfterRender, disableDrillUnderline: disableDrillUnderline }));
    };
    XirrTransformation.defaultProps = {
        config: {},
        drillableItems: [],
        onDrill: function () { return true; },
        onAfterRender: noop_1.default,
    };
    return XirrTransformation;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(XirrTransformation);
//# sourceMappingURL=XirrTransformation.js.map